import React, {useState, useEffect} from "react";
import {Popup} from "antd-mobile";
import cx from 'classnames';
import {Button, message, Modal, Space} from "antd";
import {CloseOutline} from "antd-mobile-icons";
import {useRouter} from "next/router";
import {useRequest} from "ahooks";
import PcComponentWrapper from "@/components/PcComponentWrapper";
import styles from "@/page-components/verify/QueryResult/styles.module.less";
import MobileComponentWrapper from "@/components/MobileComponentWrapper";
import {VerifyPaperData} from "@/types/verify";
import {getExamPaper} from "@/services/verify";

type TPaperView = {
  paperId: string;
}

const PaperView:React.FC<TPaperView> = ({paperId}) => {
  const router = useRouter()
  const [visible, setVisible] = useState(false);
  const [data, setData] = useState<VerifyPaperData[]>([]);
  const {run: getPaper, loading} = useRequest(() => {
    return getExamPaper({paperId});
  },{
    onSuccess:(res) => {
      if (res.code === 200){
        setData(res.data);
        if (res.data.length > 0){
          // 一张考卷直接去查看
          if (res.data.length === 1){
            router.push(`/exam/preview?paperId=${res.data[0].paperId}`)
          } else {
            setVisible(true);
          }
        } else {
          message.info('暂无考卷供查看');
        }
      } else {
        message.warning('考卷获取失败，请稍后重试');
      }
    },
    onError:() => {
      message.warning('考卷获取失败，请稍后重试');
    },
    manual: true
  })
  const renderPaper = () => {
    return data.map(item => {
      return (
        <div key={item.paperId} className={styles.verify_modal_wrapper_body_item}>
          <Space align="start">
            <img className={styles.img_icon} src={item.isPass ? "/img/detail/plan/pass.png" : "/img/detail/plan/nopass.png"} alt=""/>
            <div>
              <div className={styles.verify_modal_wrapper_item_title}>FCP-报表开发工程师（原FCRP）考试</div>
              <Space className={cx(styles.verify_modal_wrapper_item_text,styles.color_grey)}>
                成绩<span className={cx(item.isPass ? styles.color_green : styles.color_red)}>{item.score}</span>分
              </Space>
              {item.paperId && (
                <div>
                  <Space onClick={() => {
                    router.push(`/exam/preview?paperId=${item.paperId}`)
                  }} className={cx(styles.verify_modal_wrapper_item_text,styles.color_blue)}>
                    查看试卷
                  </Space>
                </div>
              )}
            </div>
          </Space>
        </div>
      )
    })
  }

  return (
    <>
      <Button loading={loading} disabled={loading} ghost className={styles.item_simplebtn} onClick={() => {
        if (paperId){
          getPaper();
        }
      }}>查看考卷</Button>
      <PcComponentWrapper>
        <Modal wrapClassName={styles.verify_modal_wrapper} centered title="选择要查看的试卷" footer={null} visible={visible} onCancel={() => {
          setVisible(false);
        }}>
          <div className={styles.verify_modal_wrapper_body}>
            {renderPaper()}
          </div>
        </Modal>
      </PcComponentWrapper>
      <MobileComponentWrapper>
        <Popup visible={visible} bodyClassName={styles.verify_modal_wrapper} onMaskClick={() => {
          setVisible(false);
        }}>
          <div className={styles.verify_modal_wrapper_body}>
            <div className={styles.header}>
              <span>请选择您要查看的考卷</span>
              <CloseOutline onClick={() => {
                setVisible(false);
              }}/>
            </div>
            <div className={styles.mobile_body}>
              {renderPaper()}
            </div>
          </div>
        </Popup>
      </MobileComponentWrapper>
    </>
  )
}
export default PaperView;
